import React from 'react'

export default function About() {
  return (
    <div
      class='w-full relative  '
      id='about'
    >
      <section class='w-full md:max-w-[90%]  mx-auto py-10 relative px-5'>
        <div class='grid md:grid-cols-2 grid-cols-1 md:gap-10 gap-2'>
          <div className='md:block hidden after:bg-[#F2CF59] after:bg-opacity-5 after:blur-2xl after:backdrop-blur-sm after:w-full after:h-full after:rounded-full after:block after:absolute relative after:top-0 after:-z-10 z-50'>
            <img
              src='/images/about.png'
              alt='about-heaidng'
              class='w-full animate__zoomIn wow animate__animated '
            />
          </div>
          <div class='flex flex-col gap-5 justify-center md:px-0 px-5'>
            <h1 className='text-5xl animate__slideInUp animate__animated wow'>
              About Us
            </h1>
            <hr
              className='w-[130px]  border-[#FFA800] border-2 '
              style={{ color: '#FFA800' }}
            />
            <p class='text-white text-base animate__slideInUp animate__animated wow'>
              At the core of Deep Whales AI is a dedicated team deeply embedded
              in the crypto community. Our journey has been forged from years of
              experience & dedication within the crypto space. We are traders,
              innovators, & visionaries, much like those we aim to serve. Our
              roots are entwined with the very community we seek to empower.{' '}
              <br /> <br /> Our mission is to deliver unmatched value through
              our suite of AI-driven trading tools. Our focus is solely on the
              success & empowerment of our users.  Our expertise & long-standing
              presence in the market speak through our work.  Deep Whales AI &
              the forthcoming suite of utilities designed to give you an almost
              unfair advantage in trading.
            </p>
          </div>
          <div className='md:hidden  block after:bg-[#F2CF59] after:bg-opacity-5 after:blur-2xl after:backdrop-blur-sm after:w-full after:h-full after:rounded-full after:block after:absolute relative after:top-0 after:-z-10 z-50'>
            <img
              src='/images/about.png'
              alt='about-heaidng'
              class='w-full  animate__slideInUp animate__animated wow'
            />
          </div>
        </div>
      </section>
    </div>
  )
}
